// extracted by mini-css-extract-plugin
module.exports = {"NewsTab":"NewsTab_NewsTab__1ohYh","activeNewsTab":"NewsTab_activeNewsTab__3RsPz"};